import PhoneIcon from '@material-ui/icons/Phone';
export const TelefoonIcon = PhoneIcon;

